import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks';
import { showCustomToast } from 'utils';
import { alertHollow, checkCircle } from 'assets/icons';
import { MetersStepType } from 'store/models/callCardStore';
import { Button } from '../../ui';

interface IProps {
  setCallCardTab?: (tab: MetersStepType) => void;
}

export const SendReadingsButton = observer(({ setCallCardTab }: IProps) => {
  const { createRequest, meters } = useStore();
  const { requestData, setActiveTab } = createRequest;

  const handleClick = () => {
    const data = meters.metersForPatchReadings.map((checkedMeter) => ({
      id: checkedMeter.id,
      values: checkedMeter.values.map(parseFloat),
    }));

    if (!setCallCardTab) {
      showCustomToast({
        title: 'Отправка показаний...',
        isLoading: true,
      });
    }

    if (requestData.area?._id) {
      meters
        .patchAreaMetersReadings(requestData.area._id, data)
        .then(() => {
          if (!setCallCardTab) {
            showCustomToast({
              title: 'Ваши показания приняты',
              icon: checkCircle,
              closeAll: true,
            });
          }

          meters.clearAreaMeters();

          return meters.getAreaMetersAllReadings({
            area: requestData.area?._id || '',
          });
        })
        .then(() => {
          setActiveTab('description');
          setCallCardTab?.('end');
        })
        .catch(() => {
          showCustomToast({
            title: 'Произошла ошибка... Попробуйте еще раз.',
            icon: alertHollow,
            closeAll: true,
          });
        });
    } else {
      showCustomToast({
        title: 'Произошла ошибка... Попробуйте еще раз.',
        icon: alertHollow,
        closeAll: true,
      });
    }
  };

  const isDisabled: boolean = useMemo(
    () =>
      !meters.hasSomeoneMeterReadingsChanges || !!meters.checkedMeters.length,
    [meters.hasSomeoneMeterReadingsChanges, meters.checkedMeters.length]
  );

  return (
    <Button
      mode={isDisabled ? 'neutral' : 'accent'}
      variant="main"
      size="m"
      disabled={isDisabled}
      onClick={handleClick}
    >
      Сохранить и продолжить
    </Button>
  );
});
